import { render } from "./AdresseView.vue?vue&type=template&id=004f858c"
import script from "./AdresseView.vue?vue&type=script&lang=js"
export * from "./AdresseView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__